<form class="mce-form-section">


    <div class="mce-form-field-group">

        <div>
            <mat-form-field>
                <mat-label>number of cables in parallel</mat-label>
                <input matInput type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" placeholder="number in parallel"
                       [formField]="form().parallelCables" />
                @for (error of form().parallelCables().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        <div>
            <mat-form-field>
                <mat-label>number of circuits</mat-label>
                <input matInput type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" placeholder="number of circuits"
                       [formField]="form().numberOfCircuits" />
                @for (error of form().numberOfCircuits().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        <div>
            <app-spacing [form]="form().circuitSpacing" label="circuit spacing"></app-spacing>
        </div>


    </div>

</form>
